import Reveal from "@/components/Reveal";

/**
 * Irish brands vs UK / international — dual call-out band.
 */
export default function IEvsUK() {
  return (
    <Reveal>
      <div className="grid grid-cols-1 md:grid-cols-2 border border-line mt-16" data-testid="ie-vs-uk">
        <div className="bg-surface px-12 py-12">
          <p className="font-mono text-[9.5px] tracking-[0.24em] uppercase text-coral mb-4">
            Irish brands
          </p>
          <h3 className="font-serif-i italic text-[26px] tracking-[-.025em] leading-[1.1] text-ink mb-3.5">
            You already hold the advantage.
          </h3>
          <p className="text-[14px] font-light text-ink-muted leading-[1.75]">
            Inside the customs union, a story that travels, and Amazon.ie as a domestic
            proving ground. <strong className="text-ink font-medium">What's missing is the operator knowledge.</strong> That's the part we
            supply.
          </p>
        </div>
        <div className="bg-navy text-white px-12 py-12">
          <p className="font-mono text-[9.5px] tracking-[0.24em] uppercase text-coral mb-4">
            UK &amp; international brands
          </p>
          <h3 className="font-serif-i italic text-[26px] tracking-[-.025em] leading-[1.1] mb-3.5">
            Ireland fixes your Brexit problem.
          </h3>
          <p className="text-[14px] font-light leading-[1.75]" style={{ color: "rgba(255,255,255,.55)" }}>
            Your EU customers may already be buying through workarounds — importing from your UK
            or US listings at worse prices.{" "}
            <strong className="text-white font-medium">
              Routed through Ireland, you get the economics of a local brand.
            </strong>{" "}
            We build that route.
          </p>
        </div>
      </div>
    </Reveal>
  );
}
